import Board from './Board.vue'

export default {
  install(Vue, options) {
    options = options || {}
    const prefix = options.prefix || ''
    Vue.component(`${prefix}Board`, Board)
  },
}
